class CamcOrbit {
    constructor(item) {
        this.carouselItem = item;
        this.startPosX = 0;
        this.startPosY = 0;
        this.startTime = null;
        this.elapsedTime = null;
        this.startEvent = null;
        this.isMoving = false;
        this.didMoved = false;
        this.onTouchMoveListener = this.throttle(this.onTouchMove.bind(this), 100);
        this.onTouchEndListener = this.throttle(this.onTouchEnd.bind(this), 100);
    }

    onTouchStart(event) {
        if (event.touches.length == 1) {
            this.startPosX = event.touches[0].pageX;
            this.startPosY = event.touches[0].pageY;
            this.startEvent = event;
            this.isMoving = true;
            this.didMoved = false;
            this.startTime = new Date().getTime();

            const orbitSlide = $(event.target).closest(".orbit-slide")[0];
            orbitSlide.addEventListener("touchmove", this.onTouchMoveListener);
            orbitSlide.addEventListener("touchend", this.onTouchEndListener);
        }
    }

    onTouchMove(event) {
        if ($.spotSwipe.preventDefault) {
            event.preventDefault();
        }

        if (this.isMoving) {
            let x = event.touches[0].pageX;
            // let y = e.touches[0].pageY;
            let dx = this.startPosX - x;
            // let dy = startPosY - y;
            let dir;
            this.didMoved = true;
            this.elapsedTime = new Date().getTime() - this.startTime;
            // if (Math.abs(dx) >= $.spotSwipe.moveThreshold && this.elapsedTime <= $.spotSwipe.timeThreshold) {
            dir = dx > 0 ? "left" : "right";
            // }
            // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
            //   dir = dy > 0 ? 'down' : 'up';
            // }
            if (dir) {
                this.onTouchEnd.apply($(event.target).closest(".orbit-slide")[0], arguments);
                $(event.target)
                    .closest(".orbit-slide")
                    .trigger($.Event("swipe", Object.assign({}, event)), dir)
                    .trigger($.Event(`swipe${dir}`, Object.assign({}, event)));
            }
        }
    }

    onTouchEnd(event) {
        const orbitSlide = $(event.target).closest(".orbit-slide")[0];
        orbitSlide.removeEventListener("touchmove", this.onTouchMoveListener);
        orbitSlide.removeEventListener("touchend", this.onTouchEndListener);

        // If the touch did not move, consider it as a "tap"
        if (!this.didMoved) {
            let tapEvent = $.Event("tap", this.startEvent || event);
            $(tapEvent.target).closest(".orbit-slide").trigger(tapEvent);
        }

        this.startEvent = null;
        this.isMoving = false;
        this.didMoved = false;
    }

    throttle(func, limit) {
        let lastFunc;
        let lastRan;
        return function (...args) {
            const context = this;
            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function () {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                }, limit - (Date.now() - lastRan));
            }
        };
    }
}

class CamcTextMediaCarousel {
    constructor(orbitWrapper, orbitTimerDelay) {
        this.orbitWrapper = orbitWrapper;
        this.orbitTimerDelay = orbitTimerDelay || 10000;
    }

    setup() {
        this.carouselOrbitElem = new Foundation.Orbit($(this.orbitWrapper).find(".orbit"), this.getOptions());
        this.camcOrbitItem = new CamcOrbit(this.carouselOrbitElem);
        this.taggleOrbitControls($(this.orbitWrapper).find(".fil-media-grid").length > 1);
        this.bindEvent();
        this.enableTouchOnMobile();
        this.setOrbitSlideHeight();
    }

    getOptions() {
        return { accessible: false, pauseOnHover: false, videoIsPlaying: false, timerDelay: this.orbitTimerDelay };
    }

    getInstance() {
        return this.carouselOrbitElem;
    }

    taggleOrbitControls(show) {
        if (show) {
            $(this.orbitWrapper).find(".orbit-controls, .orbit-bullets").show();
        } else {
            $(this.orbitWrapper).find(".orbit-controls, .orbit-bullets").hide();
        }
    }

    bindEvent() {
        this.bindOrbitSlideChange();
        this.bindCarouselAutoPlay();
        this.bindWindowSizeChange();
    }

    bindOrbitSlideChange() {
        $(this.orbitWrapper)
            .find("[data-orbit]")
            .on("beforeslidechange.zf.orbit", (e) => {
                $(this.orbitWrapper)
                    .find("video")
                    .each((index, item) => this.pauseVideo(item));
            });
        if (!Foundation.MediaQuery.is("small only")) {
            $(this.orbitWrapper)
                .find("[data-orbit]")
                .on("mouseenter.zf.orbit", () => {
                    this.carouselOrbitElem.timer.pause();
                })
                .on("mouseleave.zf.orbit", () => {
                    if (!this.carouselOrbitElem.options.videoIsPlaying) {
                        this.carouselOrbitElem.timer.start();
                    }
                });
        }
    }

    bindCarouselAutoPlay() {
        $(this.orbitWrapper)
            .find("video")
            .each((index, item) => {
                $(item).on("playing", () => {
                    this.carouselOrbitElem.options.videoIsPlaying = true;
                    this.carouselOrbitElem.timer.pause();
                });
                $(item).on("ended pause", () => {
                    this.carouselOrbitElem.options.videoIsPlaying = false;
                    this.carouselOrbitElem.timer.start();
                });
            });
    }

    enableTouchOnMobile() {
        $(this.orbitWrapper).on("touchstart", ".orbit-slide.is-active", (e) => {
            this.camcOrbitItem.onTouchStart(e);
        });
    }

    setOrbitSlideHeight() {
        this.carouselItemEqualizer(
            $(this.orbitWrapper).find(".orbit-slide"),
            ".fil-media-grid .media-grid-item .grid-x",
        );
    }

    bindWindowSizeChange() {
        $(window).on("resize", () => {
            this.setOrbitSlideHeight();
        });
    }

    carouselItemEqualizer(carouselSlide, equalizerItem) {
        let maxHeight = 0;
        carouselSlide.toArray().forEach((item) => {
            const itemHeight = this.getOrbitEqualizeritemHeight(item, equalizerItem);
            maxHeight = itemHeight > maxHeight ? itemHeight : maxHeight;
        });
        $(this.orbitWrapper).find(equalizerItem).height(maxHeight);
    }

    getOrbitEqualizeritemHeight(slideItem, equalizerItem) {
        const currentItem = $(slideItem).find(equalizerItem);
        let itemHeight = 0;
        currentItem.height("auto");
        if (slideItem.style.display === "none") {
            slideItem.style.display = "";
            itemHeight = currentItem.height();
            slideItem.style.display = "none";
        } else {
            itemHeight = currentItem.height();
        }
        return itemHeight;
    }

    pauseVideo(carouselVideo) {
        if (!carouselVideo.paused) {
            carouselVideo.pause();
        }
    }
}

module.exports = { CamcOrbit, CamcTextMediaCarousel };
